import { useEffect } from 'react';
import { useGoogleAnalytics } from '../hooks/useGoogleAnalytics';

const ScrollTracker = () => {
  const { trackScroll } = useGoogleAnalytics();

  useEffect(() => {
    let scrollTimeout;
    let lastScrollPercentage = 0;

    const handleScroll = () => {
      clearTimeout(scrollTimeout);
      
      scrollTimeout = setTimeout(() => {
        const scrollTop = window.pageYOffset;
        const docHeight = document.body.offsetHeight - window.innerHeight;
        const scrollPercentage = Math.round((scrollTop / docHeight) * 100);
        
        // Rastrear apenas quando atingir marcos específicos (25%, 50%, 75%, 100%)
        if (scrollPercentage >= 25 && lastScrollPercentage < 25) {
          trackScroll(25);
        } else if (scrollPercentage >= 50 && lastScrollPercentage < 50) {
          trackScroll(50);
        } else if (scrollPercentage >= 75 && lastScrollPercentage < 75) {
          trackScroll(75);
        } else if (scrollPercentage >= 100 && lastScrollPercentage < 100) {
          trackScroll(100);
        }
        
        lastScrollPercentage = scrollPercentage;
      }, 100); // Debounce de 100ms
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeout);
    };
  }, [trackScroll]);

  // Este componente não renderiza nada visualmente
  return null;
};

export default ScrollTracker; 